
import { IonButton, IonCol, IonContent, IonGrid, IonInput, IonLabel, IonPage, IonRow, IonText, useIonRouter } from '@ionic/react';
import React, { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Link } from "react-router-dom";
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';

interface NewPsProps {
  singIn: any,
  user?: User | null,
  refresh: any
}

const NewPs: React.FC<NewPsProps> = (props) => {


  //const history = useHistory();
  const history = useIonRouter();
  const authServ = new AuthServ();

  const siteText = translation();

  /**Define form fields */
  interface loginForm {
    email: string,
    password: string,
    code: string,
    confirm: string
  };

  const { control, handleSubmit } = useForm<loginForm>();
  const [isLogginInError, setIsLogginError] = useState<boolean>(false);



  const onSubmit: SubmitHandler<loginForm> = async (data) => {
    let lan = translation().lan.replace("/", "")
    let auth = false;
    await authServ.resetPs(data).then(resp => {
      if (resp.message) {
        auth = true;
      } else {
        setIsLogginError(true);
        return
      }
    });
    if (auth) {
      props.refresh();
      history.push(`/${lan}/signin`, 'forward', 'replace');
    }
    return
  }

  const LoginError = () => {
    if (isLogginInError) {
      return (
        <p>
          {siteText.requestNewPasswordError}
        </p>
      )
    } else {
      return <></>;
    }

  }

  return (
    <>
      <IonPage className='pageContent'>
        <IonContent>
          <IonGrid  className='sw_sp_md'>
            <IonRow className='ion-justify-content-center ion-align-items-center'>
              <IonCol sizeSm='6' sizeMd='4' className=''>
                <h1 className='ion-text-center'>{siteText.passwordResetTitle}</h1>
                <IonText color={isLogginInError ? 'danger' : 'success'}>
                  <LoginError></LoginError>
                </IonText>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <IonLabel className='ion-margin-top'>{siteText.passwordResetCodeLabel}</IonLabel>
                  <Controller
                    control={control}
                    name="code"
                    rules={{
                      required: true
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top ion-margin-bottom'
                        type="text"
                        placeholder={siteText.passwordResetCodePlaceHolder}

                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />
                  <IonLabel className='ion-margin-top'>{siteText.passwordResetEmailLabel}</IonLabel>
                  <Controller
                    control={control}
                    name="email"
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: siteText.requestNewPasswordInvalidEmail
                      }
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top ion-margin-bottom'
                        type="email"
                        placeholder={siteText.passwordResetEmailPlaceHolder}

                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />

                  <IonLabel >{siteText.passwordResetPassword}</IonLabel>
                  <Controller
                    control={control}
                    name="password"
                    rules={{
                      required: true,
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top ion-margin-bottom'
                        type="password"
                        placeholder={siteText.passwordResetPasswordPlaceHolder}
                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />

                  <IonLabel> {siteText.passwordResetConfirmPassword}</IonLabel>
                  <Controller
                    control={control}
                    name="confirm"
                    rules={{
                      required: true,
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top'
                        type="password"
                        placeholder={siteText.passwordResetConfirmPasswordPlaceHolder}
                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />
                  <div className="ion-margin-top">
                    <IonButton type="submit">{siteText.passwordResetPrimary}</IonButton>
                    <IonText><Link className='ion-padding' to='./password_reset'>{siteText.passwordResetNewCod}</Link> </IonText>
                  </div>
                </form>
              </IonCol>
            </IonRow>
          </IonGrid>
          <Footer></Footer>
        </IonContent>
      </IonPage>
    </>
  );




};

export default NewPs;
